import { type TenderLoad } from 'tender/domain/Load'

import { type RawOffer } from './RawOffer'

export type PendingResponse =
  | {
      type: 'contract'
      value: RawOffer
    }
  | {
      type: 's2c'
      value: RawOffer
    }
  | {
      type: 'tender'
      value: TenderLoad
    }

export function createContractPendingResponse(offer: RawOffer): PendingResponse {
  return {
    type: 'contract',
    value: offer,
  }
}

export function createS2CPendingResponse(offer: RawOffer): PendingResponse {
  return {
    type: 's2c',
    value: offer,
  }
}

export function createTenderPendingResponse(tenderLoad: TenderLoad): PendingResponse {
  return {
    type: 'tender',
    value: tenderLoad,
  }
}
